module.exports = __webpack_public_path__ + "/img/SOD-Labeled-Yg7G4m.svg";